import React from "react";
import { connect } from "react-redux";
import { withTheme } from "styled-components";
import BookSwimlane from "../../bookviews/book-swimlane";
import BridgeBook from "../../book/bridge-book";
import {
  actions as bridgeActions,
  selectors as bridgeSelectors
} from "../../../../../redux/bridge";
import { selectors as brandSelectors } from "../../../../../redux/brand";
import { withAllMatches } from "../../../../components/mediaquery/breakpoints";
import { subjectsParams } from "../../../../../redux/bridge/utils";
import { t } from "../../../../core/translate";

class SubjectLanes extends React.Component {
  componentDidMount() {
    const { fetchLists, subjectLanesEnabled } = this.props;
    if (subjectLanesEnabled) {
      fetchLists(subjectsParams(null, this.props.subscriptionVbid));
    }
  }

  render() {
    const {
      subjectLanesEnabled,
      subjectOne,
      subjectTwo,
      subjectThree,
      expandSwimlane,
      subjectOneMeta,
      subjectTwoMeta,
      subjectThreeMeta
    } = this.props;

    if (!subjectLanesEnabled) {
      return null;
    }

    const subjects = [subjectOne, subjectTwo, subjectThree];
    const titles = [subjectOneMeta, subjectTwoMeta, subjectThreeMeta];

    return (
      <div>
        {subjects.map((subject, i) => {
          const label =
            titles[i].filters || t("explore.recommended", "Recommended Books");
          return (
            <BookSwimlane
              key={`${label}-${i}`}
              isbns={subject.map(asset => asset.vbid)}
              BookObject={BridgeBook}
              headerLabel={label}
              onHeaderClick={() => expandSwimlane(subject, label)}
              count={subject.length}
            />
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  subjectLanesEnabled: brandSelectors.getBrandValue(
    state,
    "Subscriptions.Swimlanes.subjects"
  ),

  subjectOne: bridgeSelectors.getAssets(
    state,
    subjectsParams(0, props.subscriptionVbid)
  ),
  subjectOneMeta: bridgeSelectors.getSubjectFilters(
    state,
    subjectsParams(0, props.subscriptionVbid)
  ),
  subjectOneLoading: bridgeSelectors.isAssetsFetching(
    state,
    subjectsParams(0, props.subscriptionVbid)
  ),

  subjectTwo: bridgeSelectors.getAssets(
    state,
    subjectsParams(1, props.subscriptionVbid)
  ),
  subjectTwoMeta: bridgeSelectors.getSubjectFilters(
    state,
    subjectsParams(1, props.subscriptionVbid)
  ),
  subjectTwoLoading: bridgeSelectors.isAssetsFetching(
    state,
    subjectsParams(1, props.subscriptionVbid)
  ),

  subjectThree: bridgeSelectors.getAssets(
    state,
    subjectsParams(2, props.subscriptionVbid)
  ),
  subjectThreeMeta: bridgeSelectors.getSubjectFilters(
    state,
    subjectsParams(2, props.subscriptionVbid)
  ),
  subjectThreeLoading: bridgeSelectors.isAssetsFetching(
    state,
    subjectsParams(2, props.subscriptionVbid)
  )
});

const mapDispatchToProps = dispatch => ({
  fetchLists: lists => dispatch(bridgeActions.fetchLists(lists))
});

export default withAllMatches(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(SubjectLanes))
);
